function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTrack = function SvgTrack(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M20 6.672H6v12.925h14z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M17.242 7.545h-.848a.636.636 0 0 1-.637-.636V5.636a.636.636 0 1 1 1.273 0v1.061M10.454 7.545h-.848a.636.636 0 0 1-.637-.636V5.636a.636.636 0 1 1 1.273 0v1.061M10.386 13.586l1.697 1.72 4.242-4.242"
  }));
};
export default SvgTrack;